import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockListLayer from "../components/StockListLayer";
import { API_URL } from "..";




const StockListPage = () => {

  const [data, setData]=useState([])
  const fetchInvoices =  async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        let response = await fetch( API_URL+`/api/invoice/stock/fetch`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        console.log(data)
        setData(data.stock)
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Stock - List" />

        {/* InvoiceListLayer */}
        {
          data.length== 0 ? null :
          <StockListLayer jobsData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default StockListPage;
